import { FC } from 'react'

export type SideBarTitleProps = {
  title: string
}
export const SideBarTitle: FC<SideBarTitleProps> = ({ title }) => {
  return (
    <div className="px-xxs pb-xxxs pt-s text-sm font-semibold uppercase text-gray-500">
      {title}
    </div>
  )
}
